<template lang="pug">
.pm-overlay(v-if="visible" @click.self="onCancel")
  .pm-modal(role="dialog" aria-modal="true" aria-labelledby="pm-modal-title")

    //- ── Header ────────────────────────────────────────────────────────────
    .pm-modal__header
      span#pm-modal-title.pm-modal__title Registrar Pago Manual ID {{ ovg.id }}
      button.pm-modal__close-btn(
        @click="onCancel"
        type="button"
        aria-label="Cerrar"
        :disabled="loading"
      )
        b-icon(icon="x-lg")

    //- ── Body ──────────────────────────────────────────────────────────────
    .pm-modal__body

      //- Datos del cliente
      .pm-section
        span.pm-section__title Datos del Cliente:
        .pm-data-grid
          .pm-data-item
            span.pm-data-item__label.--blue R.U.T
            span.pm-data-item__value {{ ovg.rut || '—' }}
          .pm-data-item
            span.pm-data-item__label Nombre
            span.pm-data-item__value {{ ovg.nombre }}
          .pm-data-item
            span.pm-data-item__label Apellido
            span.pm-data-item__value {{ ovg.apellido }}
          .pm-data-item
            span.pm-data-item__label Correo Electrónico
            span.pm-data-item__value {{ ovg.correo }}
          .pm-data-item
            span.pm-data-item__label Teléfono
            span.pm-data-item__value {{ ovg.telefono || '—' }}

      //- Datos del equipo
      .pm-section
        span.pm-section__title Datos del Equipo
        .pm-data-grid
          .pm-data-item
            span.pm-data-item__label.--blue N° de Serie {{ ovg.cantidad_series > 1 ? '(' + ovg.cantidad_series + ' equipos)' : '' }}
            span.pm-data-item__value {{ ovg.numero_serie }}
          .pm-data-item
            span.pm-data-item__label Modelo del Equipo
            span.pm-data-item__value {{ ovg.modelo || '—' }}

      //- Cards de productos: extensión (si hay) + cada protección adicional
      .pm-products-list
        .pm-product-card(v-if="ovg.extension")
          b-icon.pm-product-card__icon(icon="shield-check" font-scale="2.5")
          .pm-product-card__info
            span.pm-product-card__name {{ ovg.extension.nombre }}
            span.pm-product-card__price {{ ovg.extension.precio | formatCurrency }}
        .pm-product-card(v-for="p in ovg.protecciones" :key="p.id")
          b-icon.pm-product-card__icon(icon="shield-plus" font-scale="2.5")
          .pm-product-card__info
            span.pm-product-card__name {{ p.nombre }}
            span.pm-product-card__price {{ p.precio | formatCurrency }}

      //- Cupón opcional
      .pm-section
        span.pm-section__title Cupón de descuento
        .pm-field__input-row
          input.pm-field__input(
            v-model="codigoCupon"
            placeholder="Código de descuento"
            :disabled="loading || validandoCupon || !!cuponAplicado || cuponExistente"
            @keyup.enter="validarCupon"
          )
          button.pm-btn-validar(
            v-if="!cuponAplicado && !cuponExistente"
            type="button"
            :disabled="loading || validandoCupon || !codigoCupon.trim()"
            @click="validarCupon"
          )
            b-spinner(v-if="validandoCupon" small)
            span(v-else) Aplicar
          button.pm-btn-validar(
            v-else-if="cuponAplicado"
            type="button"
            :disabled="loading"
            @click="limpiarCupon"
          ) Quitar
        p.pm-field__error(v-if="cuponError") {{ cuponError }}
        p.text-success.small.mt-1(v-if="cuponAplicado") Cupón aplicado correctamente.
        p.text-muted.small.mt-1(v-else-if="cuponExistente") Este cupón ya está asociado a la OVG.
      //- Total
      .pm-totals
        .pm-totals__row
          span.pm-totals__label Subtotal {{ ovg.cantidad_series > 1 ? '(' + ovg.cantidad_series + ' equipos)' : '' }}
          span.pm-totals__value {{ subtotal | formatCurrency }}
        .pm-totals__row(v-if="descuento > 0")
          span.pm-totals__label Descuento
          span.pm-totals__value.text-success -{{ descuento | formatCurrency }}
        .pm-totals__row
          span.pm-totals__label Total
          span.pm-totals__value {{ total | formatCurrency }}

      //- Toggle Factura
      .pm-factura-toggle
        span.pm-factura-toggle__hint Seleccione esta opción si necesitas Factura
        label.pm-factura-toggle__label(
          :class="{ '--disabled': loading }"
        )
          input(
            type="checkbox"
            v-model="esFactura"
            :disabled="loading"
            @change="onFacturaChange"
          )
          span Factura

      //- Sección Factura (cuando esFactura = true)
      .pm-factura-section(v-if="esFactura")
        .pm-field.pm-field--left
          label.pm-field__label RUT
          .pm-field__input-row
            input.pm-field__input(
              v-model="rutFormateado"
              placeholder="96.123.456-3"
              :class="{ '--error': !!rutError, '--valid': rutValidado }"
              :disabled="loading || rutValidado"
            )
            button.pm-btn-validar(
              type="button"
              :disabled="loading || !rutInput.trim() || rutValidado || validandoRut"
              @click="validarRUT"
            )
              b-spinner(v-if="validandoRut" small)
              span(v-else) Validar RUT
        p.pm-field__error(v-if="rutError") {{ rutError }}

        //- Datos del contribuyente (post-validación)
        template(v-if="contribuyenteInfo")
          .pm-field.pm-field--left
            label.pm-field__label Razón Social
            select.pm-field__input(
              v-if="opcionesRazonSocial.length > 1"
              v-model="razonSocialSeleccionada"
            )
              option(v-for="op in opcionesRazonSocial" :key="op" :value="op") {{ op }}
            input.pm-field__input(
              v-else
              :value="contribuyenteInfo.razon_social"
              disabled
            )
          .pm-field.pm-field--left
            label.pm-field__label Giro
            select.pm-field__input(
              v-if="opcionesGiro.length > 1"
              v-model="giroSeleccionado"
            )
              option(v-for="op in opcionesGiro" :key="op" :value="op") {{ op }}
            input.pm-field__input(
              v-else
              v-model="giroSeleccionado"
              disabled
            )
          .pm-field.pm-field--left
            label.pm-field__label Dirección Tributaria
            select.pm-field__input(
              v-if="opcionesSucursal.length > 1"
              :value="sucursalSeleccionadaIndex"
              @change="onSucursalChange"
            )
              option(:value="null" disabled) Seleccione una dirección
              option(
                v-for="(op, i) in opcionesSucursal"
                :key="i"
                :value="i"
              ) {{ op.label }}
            input.pm-field__input(
              v-else
              v-model="direccionSeleccionada"
              disabled
            )
          .pm-field.pm-field--left
            label.pm-field__label Comuna Tributaria
            input.pm-field__input(
              v-model="comunaSeleccionada"
              disabled
            )

    //- ── Footer ────────────────────────────────────────────────────────────
    .pm-modal__footer
      button.pm-modal__btn-cancel(
        type="button"
        :disabled="loading"
        @click="onCancel"
      ) Cancelar
      button.pm-modal__btn-confirm(
        type="button"
        :disabled="!puedeConfirmar || loading"
        @click="onConfirm"
      )
        b-spinner(v-if="loading" small)
        span(v-else) {{ confirmarLabel }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RegistrarPagoManualOVG',

  model: {
    prop: 'visible',
    event: 'update:visible',
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ovg: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      esFactura: false,
      rutInput: '',
      rutValidado: false,
      contribuyenteInfo: null,
      razonSocialSeleccionada: '',
      giroSeleccionado: '',
      direccionSeleccionada: '',
      comunaSeleccionada: '',
      sucursalSeleccionadaIndex: null,
      rutError: '',
      validandoRut: false,
      codigoCupon: '',
      cuponAplicado: null,
      cuponExistente: false,
      cuponError: '',
      validandoCupon: false,
    }
  },

  computed: {
    confirmarLabel() {
      return this.esFactura
        ? 'Confirmar y Generar Factura'
        : 'Marcar como Pagado'
    },
    puedeConfirmar() {
      if (this.esFactura) {
        return (
          this.rutValidado &&
          this.contribuyenteInfo !== null &&
          !!this.direccionSeleccionada &&
          !!this.comunaSeleccionada
        )
      }
      return true
    },
    opcionesRazonSocial() {
      const c = this.contribuyenteInfo || {}
      return c.razon_social ? [c.razon_social] : []
    },
    opcionesGiro() {
      const c = this.contribuyenteInfo || {}
      const acts = c.actividades || []
      const vistos = new Set()
      const lista = []
      acts.forEach((a) => {
        const key = a.actividadEconomica || a.giro
        if (!key || vistos.has(key)) return
        vistos.add(key)
        lista.push(key)
      })
      if (!lista.length && c.giro) lista.push(c.giro)
      return lista
    },
    opcionesSucursal() {
      const c = this.contribuyenteInfo || {}
      const sucs = c.sucursales || []
      const vistas = new Set()
      const lista = []
      sucs.forEach((s) => {
        if (!s.direccion) return
        const key = `${s.direccion}|${s.comuna || ''}`
        if (vistas.has(key)) return
        vistas.add(key)
        lista.push({
          label: s.direccion,
          direccion: s.direccion,
          comuna: s.comuna || '',
        })
      })
      return lista
    },
    subtotal() {
      return Number(this.ovg.precio_total) || 0
    },
    descuento() {
      if (this.cuponAplicado) {
        return Math.round(
          (this.subtotal * this.cuponAplicado.porcentaje_descuento) / 100
        )
      }
      return Number(this.ovg.descuento) || 0
    },
    total() {
      return Math.max(0, this.subtotal - this.descuento)
    },
    rutFormateado: {
      get() {
        return this.rutInput
      },
      set(valor) {
        const rutLimpio = valor.replace(/[^0-9kK]/g, '')
        if (rutLimpio.length === 0) {
          this.rutInput = ''
        } else if (rutLimpio.length <= 1) {
          this.rutInput = rutLimpio
        } else {
          const cuerpo = rutLimpio.slice(0, -1)
          const dv = rutLimpio.slice(-1).toUpperCase()
          const cuerpoFormateado = cuerpo
            .split('')
            .reverse()
            .join('')
            .replace(/(\d{3})(?=\d)/g, '$1.')
            .split('')
            .reverse()
            .join('')
          this.rutInput = `${cuerpoFormateado}-${dv}`
        }
        this.onRutInput()
      },
    },
  },

  watch: {
    visible(val) {
      if (!val) this.resetState()
      else this.cargarCuponExistente()
    },
  },

  methods: {
    ...mapActions('OVGCenterStore', [
      'validarContribuyenteCenter',
      'validarCuponGarantia',
    ]),

    cargarCuponExistente() {
      this.codigoCupon = this.ovg.codigo_cupon || ''
      this.cuponAplicado = null
      this.cuponExistente = !!this.ovg.codigo_cupon
      this.cuponError = ''
    },

    async validarCupon() {
      const codigo = this.codigoCupon.trim()
      if (!codigo) return
      this.validandoCupon = true
      this.cuponError = ''
      try {
        // Mismo endpoint/acción que OVGCreateView.vue (SILL-1537) — antes
        // llamaba axios directo desde el componente.
        const data = await this.validarCuponGarantia(codigo)
        this.cuponAplicado = {
          codigo: data.codigo,
          porcentaje_descuento: data.porcentaje_descuento,
        }
        this.codigoCupon = data.codigo
      } catch (err) {
        this.cuponError =
          (err.response && err.response.data && err.response.data.error) ||
          'El código de descuento no es válido o ya no está disponible.'
      } finally {
        this.validandoCupon = false
      }
    },

    limpiarCupon() {
      this.codigoCupon = ''
      this.cuponAplicado = null
      this.cuponExistente = false
      this.cuponError = ''
    },

    resetDatosContribuyente() {
      this.contribuyenteInfo = null
      this.razonSocialSeleccionada = ''
      this.giroSeleccionado = ''
      this.direccionSeleccionada = ''
      this.comunaSeleccionada = ''
      this.sucursalSeleccionadaIndex = null
    },

    onFacturaChange() {
      if (!this.esFactura) {
        this.rutInput = ''
        this.rutValidado = false
        this.resetDatosContribuyente()
        this.rutError = ''
      }
    },

    onSucursalChange(event) {
      const idx = Number(event.target.value)
      const op = this.opcionesSucursal[idx]
      if (op) {
        this.sucursalSeleccionadaIndex = idx
        this.direccionSeleccionada = op.direccion
        this.comunaSeleccionada = op.comuna
      }
    },

    onRutInput() {
      if (this.rutValidado) {
        this.rutValidado = false
        this.resetDatosContribuyente()
      }
      this.rutError = ''
    },

    async validarRUT() {
      const rut = this.rutInput.trim()
      if (!rut) {
        this.rutError =
          'El RUT de la empresa es obligatorio para emitir facturas.'
        return
      }

      this.rutError = ''
      this.rutValidado = false
      this.resetDatosContribuyente()
      this.validandoRut = true

      try {
        const rutLimpio = rut.replaceAll('.', '').trim()
        const data = await this.validarContribuyenteCenter(rutLimpio)

        if (data && data.valido) {
          this.contribuyenteInfo = data
          this.razonSocialSeleccionada = data.razon_social || ''
          const acts = data.actividades || []
          const principal = acts.find((a) => a.actividadPrincipal) || acts[0]
          this.giroSeleccionado =
            (principal && (principal.actividadEconomica || principal.giro)) ||
            data.giro ||
            ''
          const sucursalSeed = this.opcionesSucursal[0]
          this.direccionSeleccionada =
            (sucursalSeed && sucursalSeed.direccion) || data.direccion || ''
          this.comunaSeleccionada =
            (sucursalSeed && sucursalSeed.comuna) || data.comuna || ''
          this.sucursalSeleccionadaIndex =
            this.opcionesSucursal.length > 1 ? 0 : null
          this.rutValidado = true
        } else {
          this.rutError =
            (data && data.error) ||
            'El RUT ingresado no es válido. Revisa el formato (ej: 76.543.210-K).'
        }
      } catch (err) {
        this.rutError =
          (err.response && err.response.data && err.response.data.error) ||
          'El RUT ingresado no es válido. Revisa el formato (ej: 76.543.210-K).'
      } finally {
        this.validandoRut = false
      }
    },

    onConfirm() {
      const payload = {
        tipo_documento: this.esFactura ? 'factura' : 'boleta',
      }
      if (this.esFactura && this.contribuyenteInfo) {
        payload.rut_contribuyente = this.rutInput.replaceAll('.', '').trim()
        payload.giro = this.giroSeleccionado
        payload.direccion_tributaria = this.direccionSeleccionada
        payload.comuna_tributaria = this.comunaSeleccionada
        payload.razon_social_contribuyente =
          this.razonSocialSeleccionada || this.contribuyenteInfo.razon_social
      }
      if (this.cuponAplicado) payload.codigo_cupon = this.cuponAplicado.codigo
      this.$emit('confirm', payload)
    },

    onCancel() {
      this.$emit('cancel')
      this.$emit('update:visible', false)
    },

    resetState() {
      this.esFactura = false
      this.rutInput = ''
      this.rutValidado = false
      this.resetDatosContribuyente()
      this.rutError = ''
      this.validandoRut = false
      this.codigoCupon = ''
      this.cuponAplicado = null
      this.cuponExistente = false
      this.cuponError = ''
      this.validandoCupon = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

// ── Overlay ───────────────────────────────────────────────────────────────────
.pm-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px;
  overflow-y: auto;
}

// ── Modal card ────────────────────────────────────────────────────────────────
.pm-modal {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 560px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

// ── Header ────────────────────────────────────────────────────────────────────
.pm-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pm-modal__title {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #23201c;
}

.pm-modal__close-btn {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #23201c;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
}

// ── Body ──────────────────────────────────────────────────────────────────────
.pm-modal__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

// ── Section ───────────────────────────────────────────────────────────────────
.pm-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pm-section__title {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #23201c;
}

// ── Data grid ─────────────────────────────────────────────────────────────────
.pm-data-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 16px;
}

.pm-data-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pm-data-item__label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #525252;

  &.--blue {
    color: #1d4ed8;
  }
}

.pm-data-item__value {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #525252;
}

// ── Product cards ─────────────────────────────────────────────────────────────
.pm-products-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pm-product-card {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #444444;
  border-radius: 4px;
  padding: 10px;
}

.pm-product-card__icon {
  color: #525252;
  flex-shrink: 0;
}

.pm-product-card__info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.pm-product-card__name {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #525252;
}

.pm-product-card__price {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #203859;
}

// ── Totals ────────────────────────────────────────────────────────────────────
.pm-totals {
  background-color: rgba(244, 194, 53, 0.1);
  border-radius: 16px;
  padding: 20px;
}

.pm-totals__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pm-totals__label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #1d4ed8;
}

.pm-totals__value {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #1d4ed8;
}

// ── Factura toggle ────────────────────────────────────────────────────────────
.pm-factura-toggle {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pm-factura-toggle__hint {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: #525252;
}

.pm-factura-toggle__label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: #23201c;
  user-select: none;

  &.--disabled {
    opacity: 0.5;
    cursor: default;
  }

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }
}

// ── Factura section ───────────────────────────────────────────────────────────
.pm-factura-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pm-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pm-field__label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #23201c;
  text-align: right;
}

.pm-field--left {
  .pm-field__label {
    text-align: left;
  }

  .pm-field__input {
    max-width: 62%;
  }

  .pm-field__input-row {
    .pm-field__input {
      max-width: 62%;
    }
  }
}

.pm-field__input-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pm-field__input {
  flex: 1;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  height: 45px;
  padding: 8px 12px;
  border: 1px solid #525252;
  border-radius: 6px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: #23201c;
  background-color: #ffffff;
  outline: none;

  &:focus {
    border-color: #1d4ed8;
  }

  &.--error {
    border-color: #dc3545;
  }

  &.--valid {
    border-color: #28a745;
  }

  &:disabled {
    background-color: #f5f6fa;
    color: #525252;
    cursor: default;
  }
}

.pm-btn-validar {
  height: 45px;
  padding: 0 16px;
  background-color: #34c38f;
  border: none;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.pm-field__error {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #dc3545;
  margin: 0;
}

// ── Footer ────────────────────────────────────────────────────────────────────
.pm-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 45px;
}

.pm-modal__btn-cancel {
  background-color: #f5f6fa;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  height: 45px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #23201c;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: darken(#f5f6fa, 5%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.pm-modal__btn-confirm {
  background-color: $samtek-yellow;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  height: 45px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #23201c;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s, opacity 0.2s;

  &:hover:not(:disabled) {
    background-color: darken(#fece2f, 8%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
